import { ContentBlock, Box, Loader } from 'braid-design-system';

const CustomLoader = () => (
  <ContentBlock>
    <Box paddingY="xxlarge" display="flex" justifyContent="center">
      <Loader />
    </Box>
  </ContentBlock>
);

export default CustomLoader;
